import { Popup } from './popup';

const mobMenu = new Popup('#jsMenuWrap', '#jsOpenMenu', '#jsCloseMenu');
mobMenu.init();

const search = new Popup('#jsSearchWrap', '#jsOpenSearch', '#jsCloseSearch');
search.init();

const user = new Popup('#jsUserWrap', '#jsOpenUser', '#jsCloseUser');
user.init();

const cart = new Popup('#jsCartWrap', '#jsOpenCart', '#jsCloseCart');
cart.init();

const filter = new Popup('#jsFilterWrapper', '#jsOpenFilter', '#jsCloseFilter');
filter.init();

const sort = new Popup('#jsSortWrap', '#jsOpenSort', '#jsCloseSort');
sort.init();
